/* eslint-disable quote-props */
import { ADMIN_ROLES } from "../auth";

import { PartiallyMatchedEmployeeAppState } from "./common/model";
import { partiallyMatchedEmployeeSelector } from "./common/selectors";

export const routes = {
    "/partiallyMatchedEmployees": {
        title: "Partially-Matched Employees",
        authorize: [ADMIN_ROLES.ADMINISTRATOR.name, ADMIN_ROLES.SENIOR_ADMINISTRATOR.name, ADMIN_ROLES.SYSTEM_ADMIN.name],
        "/referral/:customerId/:referralId": {
            title: (state: PartiallyMatchedEmployeeAppState) =>
                partiallyMatchedEmployeeSelector(state) &&
                `${partiallyMatchedEmployeeSelector(state).firstName} ${partiallyMatchedEmployeeSelector(state).lastName}`
        },
        "/ppq/:customerId/:referralId": {
            title: (state: PartiallyMatchedEmployeeAppState) =>
                partiallyMatchedEmployeeSelector(state) &&
                `${partiallyMatchedEmployeeSelector(state).firstName} ${partiallyMatchedEmployeeSelector(state).lastName}`
        },
        "/genericCaseForm/:customerId/:referralId": {
            title: (state: PartiallyMatchedEmployeeAppState) =>
                partiallyMatchedEmployeeSelector(state) &&
                `${partiallyMatchedEmployeeSelector(state).firstName} ${partiallyMatchedEmployeeSelector(state).lastName}`
        },
        "/physiotherapyReferral/:customerId/:referralId": {
            title: (state: PartiallyMatchedEmployeeAppState) =>
                partiallyMatchedEmployeeSelector(state) &&
                `${partiallyMatchedEmployeeSelector(state).firstName} ${partiallyMatchedEmployeeSelector(state).lastName}`
        },
        "/fasttrackpitpupmedicalform/:customerId/:referralId": {
            title: (state: PartiallyMatchedEmployeeAppState) =>
                partiallyMatchedEmployeeSelector(state) &&
                `${partiallyMatchedEmployeeSelector(state).firstName} ${partiallyMatchedEmployeeSelector(state).lastName}`
        },
        "/stressriskassessment/:customerId/:referralId": {
            title: (state: PartiallyMatchedEmployeeAppState) =>
                partiallyMatchedEmployeeSelector(state) &&
                `${partiallyMatchedEmployeeSelector(state).firstName} ${partiallyMatchedEmployeeSelector(state).lastName}`
        }
    }
};
